import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "h-full w-full flex md:overflow-hidden bg-wrh-blue-background relative" }
const _hoisted_3 = { class: "flex flex-col w-0 flex-1 md:wrh-scroll" }
const _hoisted_4 = { class: "flex-1 flex justify-center relative focus:outline-none moblands:h-auto moblands:overflow-visible mt-3 mb-3" }
const _hoisted_5 = { class: "max-w-8xl mx-auto px-2 md:px-4 xl:px-10 flex-grow w-full h-full" }

import { ref, computed, onMounted } from 'vue';
import { SidebarNavigationList, StoreActions } from '../constants';
import Header from '../components/Header.vue';
import ImpersonationHeader from '@/components/ImpersonationHeader.vue';
import Sidebar from '../components/Sidebar.vue';
import Footer from '../components/Footer.vue';
import { listenToConversation } from '@/core/messages';
import store from '@/store';
import { ReqHomesDocument } from '@/models';
import Home from '@/util/home';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const selectedHome = computed(() => store.getters.selectedHome as ReqHomesDocument);
const buyerId = computed(() => store.getters.homebuyerId as string);

const { isAdditionUser } = Home.useHome();

onMounted(() => {
  if (!store.getters.messageListener && !isAdditionUser.value) {
    const {
      messages, activateListener, unsubscribe, subscribeUserListeners,
    } = listenToConversation(selectedHome.value.id, buyerId.value);
    activateListener();
    store.dispatch(StoreActions.UPDATE_MESSAGES, messages);
    store.dispatch(StoreActions.SET_MESSAGE_LISTENER, unsubscribe.value);
    store.dispatch(StoreActions.SET_CONVERSATION_LISTENER, subscribeUserListeners.value);
  } else {
    store.dispatch(StoreActions.SET_MESSAGES_SKELETON, true);
  }
});

const sidebarOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).getters.isLoginAsAdmin)
      ? (_openBlock(), _createBlock(ImpersonationHeader, {
          key: 0,
          class: "h-60px"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar, {
        sidebarOpen: sidebarOpen.value,
        navigation: _unref(SidebarNavigationList),
        onCloseSidebar: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
      }, null, 8, ["sidebarOpen", "navigation"]),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(Header, {
          sidebarOpen: sidebarOpen.value,
          navigation: _unref(SidebarNavigationList),
          onOpenSidebar: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = true)),
          onCloseSidebar: _cache[2] || (_cache[2] = ($event: any) => (sidebarOpen.value = false))
        }, null, 8, ["sidebarOpen", "navigation"]),
        _createElementVNode("main", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _createVNode(Footer)
      ])
    ])
  ]))
}
}

})